<div *ngIf="ctaAccount" class="d-flex flex-column gap-2">
  <div *ngIf="ctaAccount.title" [ngClass]="ctaAccount.title.style | floCssClassSanitize" class="color-900">{{ctaAccount.title.text}}</div>
  <flo-link class="btn-full-width" [link]="ctaAccount.createAccountButton" tagName="Button"></flo-link>
</div>
